import c from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import D from "../../../rc-util/es/hooks/useState.mjs";
import * as d from "react";
import { STEP_ACTIVE as T, STEP_ACTIVATED as e, STEP_NONE as P, STEP_PREPARE as f, STEP_START as N, STEP_PREPARED as $ } from "../interface.mjs";
import x from "./useIsomorphicLayoutEffect.mjs";
import I from "./useNextFrame.mjs";
var O = [f, N, T, e], V = [f, $], b = !1, j = !0;
function q(n) {
  return n === T || n === e;
}
const w = function(n, p, u) {
  var S = D(P), a = c(S, 2), t = a[0], r = a[1], A = I(), s = c(A, 2), v = s[0], _ = s[1];
  function R() {
    r(f, !0);
  }
  var E = p ? V : O;
  return x(function() {
    if (t !== P && t !== e) {
      var l = E.indexOf(t), o = E[l + 1], i = u(t);
      i === b ? r(o, !0) : o && v(function(C) {
        function m() {
          C.isCanceled() || r(o, !0);
        }
        i === !0 ? m() : Promise.resolve(i).then(m);
      });
    }
  }, [n, t]), d.useEffect(function() {
    return function() {
      _();
    };
  }, []), [R, t];
};
export {
  j as DoStep,
  b as SkipStep,
  w as default,
  q as isActive
};
//# sourceMappingURL=useStepQueue.mjs.map
